import { Button, Link, Popover, PopoverContent, PopoverLauncher, Typography } from '@vp/swan';
import { __ } from '@99designs/i18n';

type StandardReviewProps = {
    children: React.ReactNode;
};

export function StandardReview({ children }: StandardReviewProps) {
    return (
        <Popover position="bottom" display="inline">
            <PopoverLauncher>
                <Link
                    render={(p, ref) => (
                        <Button ref={ref} skin="link" className={p.className} {...p} />
                    )}
                >
                    {children}
                </Link>
            </PopoverLauncher>
            <PopoverContent>
                <Typography fontSkin="title-item" mb={4}>
                    {__('Review online in your own time')}
                </Typography>
                {__(
                    'Provide written feedback over 3 rounds of revisions. Receive your design within 24 hours.'
                )}
            </PopoverContent>
        </Popover>
    );
}
